import React, { useState, useEffect, useContext, useRef } from "react";
import DatePicker from "react-datepicker";
import "../../styles/projects/Projects.css";
import { MultiSelect } from "react-multi-select-component";
import api from "../../api/axiosConfig";
import { ProjectContext } from "../../App";
import { ToastContainer, toast } from "react-toastify";
import { useAuth } from "../Authentication/AuthContext";
import socket from "../../socket";

const AddProjectDial = () => {
  const [projects, setProjects] = useState([]);
  const { userDetails } = useAuth();
  const { isNavBarOpen, setAddProjectOpen } = useContext(ProjectContext);
  const [loading, setLoading] = useState(true);
  const [newProject, setNewProject] = useState({
    name: "",
    projectno: "",
    start_date: "",
    end_date: "",
    actual_hours: "",
    budget_hours: "",
    manager_id: [],
    contact_id: [],
    description: "",
    customer_id: "",
    team_id: "",
    tags: "",
    priority: "",
  });
  const [customers, setCustomers] = useState([]);
  const [filteredCustomers, setFilteredCustomers] = useState([]);
  const [selectedCustomerName, setSelectedCustomerName] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);
  const [contacts, setContacts] = useState([]);
  const [users, setUsers] = useState([]);
  const [members, setMembers] = useState([]);
  const [selectedMembers, setSelectedMembers] = useState([]);
  const [projectGroup, setProjectGroup] = useState([]);

  useEffect(() => {
    const fetchContacts = async () => {
      const customerId = newProject?.customer_id;

      if (customerId) {
        try {
          const { data } = await api.get(
            `/api/customers/${customerId}/contacts`
          );
          setContacts(data.contacts);
        } catch (error) {
          console.error("Error fetching contacts:", error);
          setContacts([]);
        }
      }
    };

    fetchContacts();
  }, [newProject?.customer_id]);
  useEffect(() => {
    socket.on("connect", () => {
      console.log("Connected to WebSocket server");
    });
    socket.on("newcustomer added", (newCustomer) => {
      setCustomers((prev) => [...prev, newCustomer]);
    });

    return () => {
      socket.off("newcustomer added");
    };
  }, []);
  useEffect(() => {
    if (userDetails) {
      setSelectedMembers((prev) => {
        // Check if the user is already in the list
        const isAlreadyAdded = prev.some(
          (member) => member.value === userDetails.id
        );
        if (isAlreadyAdded) {
          return prev; // Return the current state without changes
        }
        // Add the new user
        return [...prev, { value: userDetails.id, label: userDetails.name }];
      });
    }
  }, [userDetails]); // Only run when userDetails changes
  const handleClickOutside = (event) => {
    // Check if the click is outside the dropdown and profile
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target) //&&
      // profileRef.current &&  !profileRef.current.contains(event.target)
    ) {
      setShowDropdown(false); // Close the dropdown
    }
  };

  // Add event listener for clicks outside the component
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  useEffect(() => {
    if (newProject.customer_id) {
      const customer = customers.find(
        (c) => c.id === Number(newProject.customer_id)
      );
      const name = `${customer.customerno}-${customer.name}`;
      setSelectedCustomerName(name);
    }
  }, [newProject, customers]);
  const handleSearchChange = (e) => {
    const searchValue = e.target.value.toLowerCase();
    setSearchTerm(e.target.value);
    setSelectedCustomerName("");

    const filtered = customers.filter((customer) => {
      const name = customer.name || ""; // Fallback to an empty string
      const no = customer.customerno || ""; // Fallback to an empty string
      const displayName = customer.displayName || ""; // Fallback to an empty string

      return (
        name.toLowerCase().includes(searchValue) ||
        no.toLowerCase().includes(searchValue) ||
        displayName.toLowerCase().includes(searchValue)
      );
    });

    setFilteredCustomers(filtered);
    setShowDropdown(true); // Show the dropdown when the user types
  };

  const handleFocus = () => {
    setSearchTerm(""); // Reset the search term to show all projects
    setFilteredCustomers(customers); // Show all projects when focusing on the input
    setShowDropdown(true); // Show the dropdown
  };
  useEffect(() => {
    if (Array.isArray(newProject.manager_id) && users.length > 0) {
      const newMembers = newProject.manager_id
        .map((selected) => {
          const user = users.find((u) => u.id === Number(selected.value));
          return user ? { value: user.id, label: user.name } : null;
        })
        .filter(Boolean); // remove nulls if any user not found

      setSelectedMembers((prev) => {
        const existingIds = new Set(prev.map((m) => m.value));
        const merged = [...prev];

        newMembers.forEach((member) => {
          if (!existingIds.has(member.value)) {
            merged.push(member);
          }
        });

        return merged;
      });
    }
  }, [newProject.manager_id, users]);
  //new project dial
  const closeDialog = () => {
    setAddProjectOpen(false);
    setNewProject({
      name: "",
      projectno: "",
      start_date: "",
      end_date: "",
      actual_hours: "",
      budget_hours: "",
      manager_id: [],
      contact_id: [],
      description: "",
      customer_id: "",
      team_id: "",
      tags: "",
      priority: "",
    });
    setSelectedMembers([]);
    document.body.classList.remove("no-scroll");
  };
  //add new project
  const handleAddNewProject = async () => {
    const formatDateForMySQL = (date, daysToAdd = 0) => {
      if (!date) return null; // If no date is provided, return null

      // Convert to Date object if it's a valid date string
      let validDate = new Date(date);
      if (isNaN(validDate)) {
        return null; // Return null if invalid date
      }

      // Add the specified number of days (30 in this case)
      validDate.setDate(validDate.getDate() + daysToAdd);

      // Adjust for timezone and return as 'YYYY-MM-DD'
      const localDate = new Date(
        validDate.getTime() - validDate.getTimezoneOffset() * 60000
      );
      return localDate.toISOString().split("T")[0]; // Convert to 'YYYY-MM-DD'
    };

    let formattedProject;
    if (newProject.start_date && newProject.end_date) {
      formattedProject = {
        ...newProject,
        start_date: formatDateForMySQL(newProject.start_date),
        end_date: formatDateForMySQL(newProject.end_date),
      };
    } else {
      formattedProject = {
        ...newProject,
        start_date: formatDateForMySQL(newProject.start_date),
        end_date: formatDateForMySQL(newProject.start_date, 30), // Add 30 days to the start_date
      };
    }
    if (
      !formattedProject.projectno ||
      !formattedProject.name ||
      !formattedProject.start_date ||
      !formattedProject.customer_id ||
      !formattedProject.manager_id
    ) {
      toast.error("Check the input fields", {
        position: "bottom-center",
        autoClose: 2000,
      });
    } else {
      try {
        const response = await api.post(`/api/projects`, formattedProject);
        if (response.status === 201) {
          const newProject = response.data; // Newly created project
          const currentProjectId = newProject.id; // Get project ID

          setProjects([...projects, newProject]);
          window.location.reload();

          // After project is added, associate selected members with the new project
          if (selectedMembers.length > 0) {
            const userIds = selectedMembers.map((member) => member.value); // Extract 'value' instead of 'id'
            await handleAssociateUsersToProject(currentProjectId, userIds);
          }

          setNewProject({
            name: "",
            projectno: "",
            start_date: "",
            end_date: "",
            actual_hours: "",
            budget_hours: "",
            manager_id: [],
            contact_id: [],
            description: "",
            customer_id: "",
            team_id: "",
            tags: "",
            priority: "",
          });
          setSelectedCustomerName("");
          setTimeout(() => {
            closeDialog();
          }, 1000);
        }
      } catch (error) {
        console.error("Error adding project:", error);
        if (error.response && error.response.status === 400) {
          toast.error(error.response.data.error, {
            // Show the exact error message from the backend
            position: "bottom-center",
            autoClose: 2000,
          });
        } else {
          toast.error("Failed to add project", {
            position: "bottom-center",
            autoClose: 2000,
          });
        }
      }
    }
  };

  //add users to an project
  const handleAssociateUsersToProject = async (currentProjectId, userIds) => {
    if (userIds.length === 0 || userIds.includes(undefined)) {
      console.error("Error: Invalid user IDs", userIds);
      toast.error("Error: Invalid user selection", {
        position: "bottom-center",
        autoClose: 2000,
      });
      return;
    }

    try {
      // eslint-disable-next-line
      const response = await api.post(
        `/api/projects/${currentProjectId}/users`,
        {
          userIds: userIds,
        }
      );

      toast.error("Users associated with the project successfully.", {
        position: "bottom-center",
        autoClose: 2000,
      });
      setSelectedMembers((prev) => "");
      // Update associated and non-associated users state
    } catch (error) {
      console.error(
        "Error associating users with project:",
        error.response?.data || error.message
      );
      toast.error("Error associating users with project. Please try again.", {
        position: "bottom-center",
        autoClose: 2000,
      });
    }
  };

  //fetching admin users
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await api.get(`/api/users`);
        const activeUsers = res.data.filter(
          (member) => member.status !== "Inactive"
        );
        setUsers(activeUsers);
        setLoading(false);
      } catch (error) {
        console.log(error);
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  //fetching all users and customers
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await api.get(`/api/users`);
        const cusres = await api.get(`/api/customers`);
        const groupres = await api.get(`/api/groups`);
        const formattedMembers = res.data
          .filter((member) => member.status !== "Inactive") // Filter out inactive members
          .map((member) => ({
            value: member.id, // Assuming `id` is a unique identifier
            label: member.name, // Display the name as the label
          }))
          .sort((a, b) => {
            return a.label.localeCompare(b.label);
          });

        setMembers(formattedMembers);
        setCustomers(cusres.data);
        setProjectGroup(groupres.data);
        setLoading(false);
      } catch (error) {
        console.log(error);
        setLoading(false);
      } finally {
        setLoading(false); // Always stop loading after attempting to fetch
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <div
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      >
        <span className="loading-animation">LOADING...</span>
      </div>
    );
  }

  return (
    <div style={{ position: "relative", left: isNavBarOpen ? "0px" : "-80px" }}>
      <ToastContainer />
      <>
        <div className="add-project-dial slide-in-right">
          <div className="add-new-project-content">
            <div className="add-project-user-header">
              <h3
                className="add-project-user-heading"
                style={{ marginLeft: "14px" }}
              >
                New Project
              </h3>
            </div>
            <div className="project-name-number-container">
              <div className="name-container">
                <h3 className="box-heading">Project No</h3>
                <input
                  className="box-input"
                  placeholder="Enter Project No"
                  value={newProject.projectno}
                  maxLength={20}
                  onChange={(e) =>
                    setNewProject((prev) => ({
                      ...prev,
                      projectno: e.target.value,
                    }))
                  }
                />
              </div>
              <div className="name-container" style={{ marginLeft: "14px" }}>
                <h3 className="box-heading">Project Name</h3>
                <input
                  className="box-input"
                  placeholder="Enter Project Name"
                  value={newProject.name}
                  maxLength={50}
                  onChange={(e) =>
                    setNewProject((prev) => ({
                      ...prev,
                      name: e.target.value,
                    }))
                  }
                />
              </div>
            </div>
            <div className="start-date-due-date-container">
              <div className="start-dat-container">
                <h3 className="box-heading">Start date</h3>
                <DatePicker
                  placeholderText="dd-mm-yyyy"
                  selected={newProject.start_date}
                  onChange={(date) =>
                    setNewProject((prev) => ({
                      ...prev,
                      start_date: date,
                    }))
                  }
                  dateFormat="dd-MM-yyyy"
                  className="box-input"
                  maxDate={newProject.end_date}
                />
              </div>
              <div className="due-date-container">
                <h3 className="box-heading">Due date</h3>
                <DatePicker
                  placeholderText="dd-mm-yyyy"
                  selected={newProject.end_date}
                  onChange={(date) =>
                    setNewProject((prev) => ({
                      ...prev,
                      end_date: date,
                    }))
                  }
                  dateFormat="dd-MM-yyyy"
                  className="box-input"
                  minDate={newProject.start_date}
                />
              </div>
            </div>
            <div className="project-owner-budget-container">
              <div className="owner-container">
                <h3 className="box-heading">Select Customer</h3>
                <input
                  className="box-input"
                  placeholder="Search Customer"
                  ref={dropdownRef}
                  value={searchTerm || selectedCustomerName}
                  onChange={handleSearchChange}
                  onFocus={handleFocus}
                  onMouseDown={() => handleClickOutside}
                />
                {showDropdown &&
                  (showDropdown && filteredCustomers?.length > 0 ? (
                    <ul
                      style={{ zIndex: "50" }}
                      ref={dropdownRef}
                      className="project-p-display-box"
                    >
                      {filteredCustomers.map((customer) => (
                        <li
                          key={customer.id}
                          value={customer.id}
                          onClick={() => {
                            setNewProject((prev) => ({
                              ...prev,
                              customer_id: customer.id,
                            }));
                            setShowDropdown(false);
                            setSearchTerm("");
                          }}
                          onMouseDown={() => handleClickOutside}
                          className="project-dropdown-item"
                        >
                          {customer.customerno}-{customer.name}
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <p>No Customers available</p>
                  ))}
              </div>
              <div className="name-container" style={{ marginLeft: "14px" }}>
                <h3 className="box-heading">Project Group</h3>
                <select
                  className="select-d-input"
                  style={{ marginTop: "0px", backgroundColor: "white" }}
                  value={newProject.team_id}
                  onChange={(e) => {
                    const selectedGroupId = e.target.value;
                    setNewProject((prev) => ({
                      ...prev,
                      team_id: selectedGroupId,
                    }));
                  }}
                >
                  <option value="" disabled>
                    Select Group
                  </option>
                  {projectGroup.map((group) => (
                    <option key={group.id} value={group.id}>
                      {group.code}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="add-description-container ">
              <div className="priority-container">
                <div style={{ backgroundColor: "transparent" }}></div>
              </div>
              <div style={{ display: "flex" }}>
                <div className="tags-container"></div>
              </div>
            </div>
            <div className="project-select-container">
              <div className="owner-container">
                <h3 className="box-heading" style={{ margin: "3px" }}>
                  Contact
                </h3>
                <MultiSelect
                  value={newProject.contact_id} // ⬅️ Always pass the selected value here
                  options={contacts.map((contact) => ({
                    label: contact.contact_name,
                    value: String(contact.contact_id),
                  }))}
                  className="member-select-option"
                  onChange={(e) => {
                    setNewProject((prev) => ({
                      ...prev,
                      contact_id: e,
                    }));
                  }}
                  display="chip"
                  placeholder="Select Project Managers"
                />
              </div>
              <div className="owner-container">
                <h3 className="box-heading" style={{ margin: "1px" }}>
                  Owner
                </h3>
                <MultiSelect
                  value={newProject.manager_id} // ⬅️ Always pass the selected value here
                  options={users
                    .sort((a, b) => a.name.localeCompare(b.name))
                    .map((user) => ({
                      label: user.name,
                      value: String(user.id),
                    }))}
                  className="member-select-option"
                  onChange={(e) => {
                    setNewProject((prev) => ({
                      ...prev,
                      manager_id: e,
                    }));
                  }}
                  display="chip"
                  placeholder="Select Project Managers"
                />
              </div>
            </div>
            <div className="project-details-container">
              <h3 className="box-heading">Project Members</h3>
              <MultiSelect
                options={members}
                value={selectedMembers}
                onChange={setSelectedMembers}
                className="member-select-option"
              />
            </div>
            <div style={{ backgroundColor: "transparent" }}>
              <h3 className="box-heading">Add Description</h3>
              <textarea
                className="box-des-input"
                placeholder="Enter Description"
                value={newProject.description}
                maxLength={100}
                onChange={(e) =>
                  setNewProject((prev) => ({
                    ...prev,
                    description: e.target.value,
                  }))
                }
              />
            </div>
            <div className="add-new-project-button-container">
              <button className="add-btn" onClick={handleAddNewProject}>
                Add
              </button>
              <button onClick={closeDialog} className="cancel-btn">
                Cancel
              </button>
            </div>
          </div>
        </div>
      </>
    </div>
  );
};

export default AddProjectDial;
